import { Link } from 'react-router-dom'
import { CityIcon } from '@/shared/ui/icons/CityIcon'
import { MessageIcon } from '@/shared/ui/icons/MessageIcon'

export function HomeHero() {
  return (
    <section className="flex flex-col gap-6 p-4">
      <h1 className="m-0 min-h-[135px] text-headline-md font-medium tracking-[-0.14px] text-black-800">
        우리 동네의 문제,
        <br />
        함께 <Marked>해결해 봄 !</Marked>
      </h1>

      <div className="flex items-center gap-2">
        <Link
          className="ui-pressable flex h-[46px] min-w-px flex-1 shrink-0 grow basis-0 cursor-pointer items-center justify-center gap-2 rounded-xl border-0 bg-violet-500 px-3 py-2.5 font-base text-body-md font-medium whitespace-nowrap text-white-50"
          to="/problems/new"
        >
          <MessageIcon size={22} />
          동네 문제 등록하기
        </Link>
        <Link
          className="ui-pressable flex h-[46px] shrink-0 cursor-pointer items-center justify-center gap-1.5 rounded-xl border border-white-500 bg-white-50 px-3.5 py-2.5 font-base text-body-md font-normal whitespace-nowrap text-black-600"
          to="/orgs/new"
        >
          <CityIcon size={20} />
          기업 등록하기
        </Link>
      </div>
    </section>
  )
}

function Marked({ children }: { children: React.ReactNode }) {
  return (
    <span className="relative inline-block text-violet-500">
      {children}
      <svg
        className="absolute bottom-[-6px] left-0 h-[13px] w-full"
        viewBox="0 0 110 13"
        preserveAspectRatio="none"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.957 4.13461C109.508 2.60205 105.651 1.95676 94.0604 1.41902C83.2451 0.908165 70.6544 -0.570633 48.6563 0.235981C31.8415 0.854384 10.9046 3.328 10.9046 4.69924C10.9046 5.69407 11.7208 5.72095 19.516 4.83368C26.7195 4.02706 30.413 3.83885 34.9228 3.62376C16.8428 5.72095 12.986 7.0922 3.35422 8.40967C-2.68606 9.24317 0.844238 11.6361 3.04812 11.3941C3.06853 11.3941 31.1681 8.38278 33.8209 8.5441C34.0658 8.57099 31.3925 9.05496 27.8622 9.61959C18.006 11.2328 19.9038 13.9213 27.2909 12.6844C52.1458 8.51694 75.5315 7.22636 93.5503 9.0278C99.2436 9.59243 99.8762 9.59243 99.8762 8.89336C99.8762 7.65655 98.3254 6.71578 95.897 6.52757C92.1014 6.20492 77.4905 5.29049 70.8788 5.02162C70.3687 4.99473 70.6135 4.48415 71.0625 4.43037C73.7561 4.08084 95.142 4.34944 103.549 4.72586C109.733 4.99473 110.181 4.96811 109.957 4.13461Z"
          fill="#d4c3f3"
          fillOpacity="0.6"
        />
      </svg>
    </span>
  )
}
